module.exports = __webpack_public_path__ + "media/images/icons/location-808a51a2dd10ec65627f4e98b6c4f522.svg";